export default "__VITE_PUBLIC_ASSET__a2cf9bc8__"